import { superAdminApi } from '@/core/api/super-admin'

export const { useAssignAdminLicensesMutation, useCreateAdminMutation, useDeleteAdminMutation, useGetEstablishmentAdminsQuery } = superAdminApi
